import actionTypes from 'dashboard/actions/bond-renewal/action-types';

export default (state = {}, action) => {
  switch (action.type) {
    case actionTypes.FETCH_BOND_RENEWAL_SUCCESS:
      return { ...action.stores };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/dashboard/reducers/bond-renewal/stores.js